import styled from '@emotion/styled';

import { Button as MuiButton } from 'components/Buttons';

export const Button = styled(MuiButton)`
  &:focus,
  &:active,
  &:hover {
    color: currentColor;
  }

  .MuiButton-endIcon {
    margin-left: 6px;
  }
`;
